import { render, staticRenderFns } from "./VideosStreamlineSettings.vue?vue&type=template&id=ed6bee10&scoped=true"
import script from "./VideosStreamlineSettings.vue?vue&type=script&lang=js"
export * from "./VideosStreamlineSettings.vue?vue&type=script&lang=js"
import style0 from "./VideosStreamlineSettings.vue?vue&type=style&index=0&id=ed6bee10&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed6bee10",
  null
  
)

export default component.exports